export enum CounterpartyType {

    COMPANY = "COMPANY",
    PERSON = "PERSON"
}